import { last } from 'lodash';

/**
 * Ottiene l'estensione di un file.
 */
export function attachmentExtension(fileName: string | undefined) {
  if (!fileName) return null;
  return (last(fileName.split('.')) || '').toLowerCase();
}
